// extracted by mini-css-extract-plugin
module.exports = {"insightsContainer":"Qv5p6WOn","count":"p3QdA1Rq","countDisabled":"_nBfkThP"};